module.exports = __webpack_public_path__ + "static/media/signup.78c2f52e.jpg";